import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { DataMap } from '@grapecity/wijmo.grid'

import { ListItem, ProposalBid, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './proposal-bid.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class ProposalBidComponent extends RepositoryModal<ProposalBid> {
    ownersList: ListItem<number>[] = []
    jobTypesList: ListItem<string>[] = []
    countiesList: ListItem<string>[] = []

    protected onInitialized() {
        const ownersMap = this.editOptions.initializeParams.ownersMap as DataMap
        const jobTypeMap = this.editOptions.initializeParams.jobTypeMap as DataMap
        const countiesMap = this.editOptions.initializeParams.countiesMap as DataMap

        if (ownersMap) {
            this.ownersList = ownersMap.collectionView.items.map(i => new ListItem(i.id, i.name))
        }
        if (jobTypeMap) {
            this.jobTypesList = jobTypeMap.collectionView.items.map(i => new ListItem(i.id, i.fullName))
        }
        if (countiesMap) {
            this.countiesList = countiesMap.collectionView.items.map(i => new ListItem(i.id, i.combinedName))
        }
    }
}
